import moment from 'moment';

export const filters: any = {
  UPY3: () => {
    return {
      layout: [
        {
          name: 'startDate',
          label: 'Start Date',
          type: 'date',
          inputProps: {
            showToday: true,
            showYesterday: true,
          },
        },
        {
          name: 'endDate',
          label: 'End Date',
          type: 'date',
          inputProps: {
            showToday: true,
            showYesterday: true,
          },
        },
        {
          name: 'department',
          label: 'Department',
          options: [
            { label: 'Service', value: 'service' },
            { label: 'Parts', value: 'parts' },
          ],
          allowEmptyOption: true,
        },
        {
          name: 'status',
          label: 'Status',
          options: [
            { label: 'Open', value: 'open' },
            { label: 'Complete', value: 'complete' },
            { label: 'Canceled', value: 'canceled' },
          ],
          allowEmptyOption: true,
        },
      ],
      fields: {
        startDate: {
          name: 'id',
          process: (value: string) => moment(value, 'MM-DD-YYYY').startOf('day').format('x'),
          op: 'gte',
          type: 'flake',
        },
        endDate: {
          name: 'id',
          process: (value: string) => moment(value, 'MM-DD-YYYY').endOf('day').format('x'),
          op: 'lte',
          type: 'flake',
        },
        department: {
          name: '$PaymentSession.department$',
          op: 'eq',
        },
        status: {
          name: '$PaymentSession.status$',
          op: 'eq',
        },
      },
    };
  },
};

export const getFilter = (name: string) => {
  return filters[name] && filters[name]();
};
